import { render } from "./Landing.vue?vue&type=template&id=0d7a9e3f"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=0d7a9e3f&lang=postcss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__